import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const PricingCard = ({ title, description, priceRange, features, isRecommended = false }) => {
  return (
    <div className={`
      relative p-6 md:p-8 rounded-2xl transition-all duration-300 hover:-translate-y-1
      ${isRecommended 
        ? 'bg-primary/10 border-2 border-primary shadow-xl' 
        : 'bg-card border border-border hover:border-primary/50'
      }
    `}>
      {isRecommended && (
        <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-primary text-primary-foreground text-xs font-bold rounded-full whitespace-nowrap">
          RECOMMENDED
        </div>
      )}
      <div className="text-center mb-6 md:mb-8">
        <h3 className="text-2xl md:text-3xl font-bold font-heading text-foreground mb-2 md:mb-3">
          {title}
        </h3>
        <p className="text-sm md:text-base text-muted-foreground mb-4 md:mb-6">
          {description}
        </p>
        <div className="text-3xl md:text-4xl font-bold text-primary">
          {priceRange}
        </div>
        <p className="text-xs md:text-sm text-muted-foreground mt-2">
          per project
        </p>
      </div>
      <ul className="space-y-3 md:space-y-4 mb-6 md:mb-8">
        {features?.map((feature, index) => (
          <li key={index} className="flex items-start gap-3">
            <Icon 
              name="CheckCircle2" 
              size={20} 
              color="var(--color-success)" 
              className="flex-shrink-0 mt-0.5" 
            />
            <span className="text-sm md:text-base text-foreground">{feature}</span>
          </li>
        ))}
      </ul>
      <Link to="/contact" className="block">
        <Button 
          variant={isRecommended ? "default" : "outline"} 
          fullWidth
          iconName="ArrowRight"
          iconPosition="right"
        >
          Get Started
        </Button>
      </Link>
    </div>
  );
};

export default PricingCard;